<template>
  <div>
    <div class="box" v-if="user.grant.users.grant">
      <h4>Definition des droits</h4>
      <div class="first_box mt-5">
        <vs-checkbox :disabled="profile == '2' ? true : false" v-model="form.dashboard">Tableau de bord</vs-checkbox>
        <vs-checkbox :disabled="profile == '1' ? true : false" v-model="form.payments">Liste des paiements</vs-checkbox>
        <vs-checkbox :disabled="profile == '1' ? true : false" v-model="form.validate">Valider une consultation</vs-checkbox>
      </div>

      <div class="mt-5">
        <fieldset>
          <legend>Module spécialité</legend>
          <div class="first_box p-5">
            <vs-checkbox v-model="form.specialities.list">Liste des spécialités</vs-checkbox>
            <vs-checkbox v-model="form.specialities.create">Ajouter une spécialité</vs-checkbox>
            <vs-checkbox v-model="form.specialities.update">Modifier une spécialité</vs-checkbox>
            <vs-checkbox v-model="form.specialities.delete">Supprimer une spécialité</vs-checkbox>
          </div>
        </fieldset>
      </div>

      <div class="mt-5">
        <fieldset>
          <legend>Module praticien</legend>
          <div class="first_box p-5">
            <vs-checkbox v-model="form.praticiens.list">Liste des praticiens</vs-checkbox>
            <vs-checkbox v-model="form.praticiens.create">Ajouter un praticien</vs-checkbox>
            <vs-checkbox v-model="form.praticiens.update">Modifier un praticien</vs-checkbox>
            <vs-checkbox v-model="form.praticiens.delete">Supprimer un praticien</vs-checkbox>
          </div>
        </fieldset>
      </div>

      <div class="mt-5">
        <fieldset>
          <legend>Module vérification des paiements</legend>
          <div class="first_box p-5">
            <vs-checkbox v-model="form.verify.list">Liste des paiements a vérifier</vs-checkbox>
            <vs-checkbox v-model="form.verify.check">Vérifier l'état d'un paiement</vs-checkbox>
            <vs-checkbox v-model="form.verify.create">Ajouter un paiement</vs-checkbox>
          </div>
        </fieldset>
      </div>

      <div class="mt-5">
        <fieldset>
          <legend>Module utilisateur</legend>
          <div class="first_box p-5">
            <vs-checkbox v-model="form.users.list">Liste des utilisateurs</vs-checkbox>
            <vs-checkbox v-model="form.users.create">Ajouter un utilisateur</vs-checkbox>
            <vs-checkbox v-model="form.users.update">Modifier un utilisateur</vs-checkbox>
            <vs-checkbox v-model="form.users.delete">Supprimer un utilisateur</vs-checkbox>
            <vs-checkbox v-model="form.users.grant">Gestion des droits</vs-checkbox>
          </div>
        </fieldset>
      </div>

      <div class="first_box mt-5">
        <vs-checkbox v-model="form.log">Consulter les logs</vs-checkbox>
        <vs-checkbox v-model="form.statistics_payment">Statistique paiement</vs-checkbox>
        <vs-checkbox v-model="form.chiffre">Statistique sur le chiffre d'affaire</vs-checkbox>
      </div>

      <div class="mt-5 f-end">
        <vs-button @click="updateGrant" class="z-8" color="primary" type="filled">Enregistrer</vs-button>
      </div>

    </div>
    <div v-else>
      <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="@/assets/images/pages/404.png" alt="graphic-404" class="mx-auto mb-4 max-w-full">
            <h1 class="sm:mx-0 mx-4 mb-12 text-3xl d-theme-heading-color">404 - Page introuvable!</h1>
            <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-heading-color">La page que vous demandez est introuvable</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    form: {
      dashboard: false,
      payments: false,
      validate: false,
      specialities:{
        list: false,
        create: false,
        delete: false,
        update: false
      },
      praticiens:{
        list: false,
        create: false,
        delete: false,
        update: false
      },
      users:{
        create: false,
        delete: false,
        update: false,
        grant: false
      },
      log: false,
      statistics_payment: false,
      chiffre: false,
      verify:{
        list: false,
        check: false,
        create: false
      }
    },
    profile: '',
    user: {}
  }),
  created(){
    this.user = JSON.parse(localStorage.getItem('user_cnhu'))
  },
  mounted(){
    if (this.user.grant.users.grant){
      this.getData()
    }
  },
  methods:{
    getData() {
      this.$vs.loading();
      this.$http
        .get("/users/grant?id="+this.$route.params.id)
        .then((response) => {
          this.form = response.data.grant
          this.profile = response.data.profile
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "page-login"})
          }
        });
      },

      updateGrant() {
      this.$vs.loading();
      this.$http
        .post("/users/grant", {
          id: this.$route.params.id,
          grant: this.form
        })
        .then(() => {
          this.$vs.notify({
            title: 'Information',
            text: 'Opération éffectuée',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check',
            position: 'top-right'
          })
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "page-login"})
          }
        });
      }
  }
}
</script>

<style lang="scss" scoped>
  .box{
    background-color: #fff;
    border-radius: 10px;
    min-height: 100px;
    padding: 10px;
  }
  .first_box{
    display: flex;
    gap: 10px;
    height: auto;
    flex-wrap: wrap;
  }
  .f-end{
    display: flex;
    justify-content: flex-end;
  }
</style>
